<script lang="ts">
  import { page } from "$app/state";
  import { getSessionContext } from "@/shared/lib/layoutContext";
  import { supabase } from "@/shared/api/supabaseClient";
  import { resolve } from "$app/paths";

  let { full }: { full: boolean } = $props();

  const getSession = getSessionContext();
  let session = $derived(getSession().session);

  let mobileMenuOpen = $state(false);

  // Close menu on navigation
  $effect(() => {
    void page.url.pathname;
    mobileMenuOpen = false;
  });

  async function signOut() {
    await supabase.auth.signOut();
    window.location.href = resolve("/");
  }
</script>

<header
  class="bg-chrome-bg border-t-2 border-t-accent border-b border-b-chrome-border relative w-screen"
>
  <div class={["mx-auto px-4 sm:px-6 lg:px-8", full || "max-w-7xl"]}>
    <div class="flex justify-between items-center h-14">
      <div class="flex items-center">
        <a href={resolve("/")} class="no-underline hover:no-underline">
          <img src="/logo-small.svg" alt="Warboard" class="h-10 w-auto" />
        </a>
      </div>

      <nav class="flex items-center gap-1 flex-wrap justify-end">
        {#if session}
          <span
            class="hidden sm:inline text-[0.8rem] text-text-secondary px-2 py-2 truncate max-w-[160px]"
          >
            {session.user.email}
          </span>
          <a
            href={resolve("/rules")}
            class="hidden sm:inline text-[0.875rem] font-medium text-text-secondary px-2 py-2 no-underline hover:text-text-primary hover:no-underline aria-[current=page]:text-text-primary"
            aria-current={page.url.pathname.startsWith("/rules") ? "page" : undefined}
          >
            Rules
          </a>
          <a
            href={resolve("/tables")}
            class="text-[0.875rem] font-medium text-text-secondary px-2 py-2 no-underline hover:text-text-primary hover:no-underline aria-[current=page]:text-text-primary"
            aria-current={page.url.pathname === "/tables" ? "page" : undefined}
          >
            Tables
          </a>
          <a
            href={resolve("/account/notifications")}
            class="hidden sm:inline text-[0.875rem] font-medium text-text-secondary px-2 py-2 no-underline hover:text-text-primary hover:no-underline aria-[current=page]:text-text-primary"
            aria-current={page.url.pathname === "/account/notifications" ? "page" : undefined}
          >
            Notifications
          </a>
          <a
            href={resolve("/help")}
            class="hidden sm:inline text-[0.875rem] font-medium text-text-secondary px-2 py-2 no-underline hover:text-text-primary hover:no-underline aria-[current=page]:text-text-primary"
            aria-current={page.url.pathname.startsWith("/help") ? "page" : undefined}
          >
            Help
          </a>
          <button
            onclick={() => (mobileMenuOpen = !mobileMenuOpen)}
            class="sm:hidden flex flex-col justify-center items-center gap-[5px] p-2 border border-chrome-border bg-transparent cursor-pointer"
            aria-label="Menu"
            aria-expanded={mobileMenuOpen}
          >
            <span class="block w-5 h-[2px] bg-text-secondary"></span>
            <span class="block w-5 h-[2px] bg-text-secondary"></span>
            <span class="block w-5 h-[2px] bg-text-secondary"></span>
          </button>
          <button
            onclick={signOut}
            class="text-[0.875rem] font-medium text-text-secondary border border-chrome-border px-3 min-h-[44px] bg-transparent cursor-pointer no-underline inline-flex items-center hover:text-text-primary hover:bg-chrome-bg-raised hover:no-underline"
          >
            Sign Out
          </button>
        {:else}
          <a
            href={resolve("/login")}
            class="text-[0.875rem] font-medium text-text-secondary px-3 min-h-[44px] inline-flex items-center no-underline hover:text-text-primary hover:no-underline aria-[current=page]:text-text-primary"
            aria-current={page.url.pathname === "/login" ? "page" : undefined}
          >
            Sign In
          </a>
          <a
            href={resolve("/login")}
            class="text-[0.875rem] font-medium text-text-secondary border border-chrome-border px-3 min-h-[44px] no-underline inline-flex items-center hover:text-text-primary hover:bg-chrome-bg-raised hover:no-underline"
          >
            Sign Up
          </a>
        {/if}
      </nav>
    </div>
  </div>
  {#if mobileMenuOpen && session}
    <div class="sm:hidden bg-chrome-bg border-b border-chrome-border px-4 py-3 flex flex-col gap-1">
      <span class="text-[0.75rem] text-text-muted truncate mb-1">{session.user.email}</span>
      <a
        href={resolve("/rules")}
        onclick={() => (mobileMenuOpen = false)}
        class="text-[0.875rem] font-medium text-text-secondary px-2 py-2 no-underline hover:text-text-primary hover:no-underline block"
        aria-current={page.url.pathname.startsWith("/rules") ? "page" : undefined}>Rules</a
      >
      <a
        href={resolve("/account/notifications")}
        onclick={() => (mobileMenuOpen = false)}
        class="text-[0.875rem] font-medium text-text-secondary px-2 py-2 no-underline hover:text-text-primary hover:no-underline block"
        aria-current={page.url.pathname === "/account/notifications" ? "page" : undefined}
        >Notifications</a
      >
      <a
        href={resolve("/help")}
        onclick={() => (mobileMenuOpen = false)}
        class="text-[0.875rem] font-medium text-text-secondary px-2 py-2 no-underline hover:text-text-primary hover:no-underline block"
        aria-current={page.url.pathname.startsWith("/help") ? "page" : undefined}>Help</a
      >
    </div>
  {/if}
</header>
